import { ServiceResponse } from 'loca-boot-core'
import { RecommendRoutes, RouteModelDetail } from './recommend.model'

/**
 * 获取CDN资源
 * @returns
 */
export const getChargingTripRouteCDN = async (cdnLink: string) => {
  return new Promise<RouteModelDetail[]>((resolve) => {
    if (cdnLink) {
      window
        .fetch(cdnLink)
        .then((response) => response.json())
        .then((json) => {
          const data = new ServiceResponse<RecommendRoutes>(
            {
              data: { routes: json },
            },
            RecommendRoutes
          ).data.routes
          resolve(data)
        })
    } else {
      resolve([] as RouteModelDetail[])
    }
  })
}
